import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { useWindowSize } from "@hooks/useWindowSize";
import SectionHeading from "@routes/Section/components/SectionHeading";
import ArticleList from "@routes/ZhHans/components/ArticleList/ArticleList";
import { ZhHansPageData } from "@routes/ZhHans/utils/types";

/**
 * The content of the zh-hans page.
 * @figma https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/WEB-BAU-2025?node-id=16171-18324&t=QZPAjkqVKrSzpWQN-4
 * */
const ZhHansPageContent = ({
  articles,
  seoFooterData,
  gaProps,
}: ZhHansPageData & { gaProps: GADataProps }): React.ReactElement => {
  useInjectClientData({ gaProps });

  const { isScreenLG } = useWindowSize();

  return (
    <div data-testid="zh-hans-page-content-component" className="w-full">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <Container rootClassName="pb-6">
        <SectionHeading
          text="商业时报中文版 (beta)"
          className="mb-6 font-notoSerifSc"
          hasBorder
        />

        <div className="grid gap-6 lg:grid-cols-3">
          <ArticleList cardProps={articles} className="lg:col-span-2" />

          {isScreenLG ? (
            <div className="lg:col-span-1">
              <Ad
                adType="imu2"
                className="flex flex-col items-center justify-center lg:!sticky lg:top-18"
              />
            </div>
          ) : null}
        </div>
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default ZhHansPageContent;
